export function updateButtonLoadingState(button) {
  const iconBefore = button.querySelector('.js-c-ui-button__icon--before')
  const iconLoading = button.querySelector('.js-c-ui-button__icon--loading')

  if (!iconLoading) return

  const isLoading = button.getAttribute('data-loading') === 'true'

  if (isLoading) {
    if (button.loadingWasDisabled === undefined) button.loadingWasDisabled = button.disabled
    if (iconBefore) iconBefore.classList.add('tw-hidden')
    iconLoading.classList.remove('tw-hidden')
    button.classList.add('tw-opacity-70', 'tw-cursor-wait')
    button.setAttribute('disabled', 'true')
  } else {
    if (iconBefore) iconBefore.classList.remove('tw-hidden')
    iconLoading.classList.add('tw-hidden')
    button.classList.remove('tw-opacity-70', 'tw-cursor-wait')
    if (!button.loadingWasDisabled) button.removeAttribute('disabled')
    button.loadingWasDisabled = undefined
  }
}
